import React from 'react';
import { Link } from 'react-router-dom';

const Datenschutz = () => {
  return (
    <div className="min-h-screen bg-white py-20">
      <div className="max-w-2xl mx-auto px-6">
        <Link to="/" className="text-xs uppercase tracking-widest text-gray-400 hover:text-gray-800 mb-12 inline-block">← Zurück</Link>
        
        <div className="prose prose-sm prose-gray">
          <h1 className="text-2xl font-light mb-12">Datenschutzerklärung</h1>
          
          <h2 className="text-lg font-light mt-8">Verantwortliche Stelle</h2>
          <p>
            Nadine Rau u. Mike Trepte GbR<br />
            Bettenhäuserstraße 1<br />
            34123 Kassel<br />
            E-Mail: mike@underopensky.de<br />
            Telefon: 0561 / 43027276
          </p>

          <h2 className="text-lg font-light mt-8">Überblick</h2>
          <p>
            Diese Website verwendet keine Cookies, keine Tracking-Dienste und keine Analyse-Tools. 
            Personenbezogene Daten werden nur erfasst, wenn Sie uns diese aktiv mitteilen (z.B. per E-Mail).
          </p>

          <h2 className="text-lg font-light mt-8">Ihre Rechte</h2>
          <p>
            Sie haben jederzeit das Recht auf Auskunft, Berichtigung, Löschung oder Einschränkung der Verarbeitung Ihrer gespeicherten Daten.
          </p>

          <p className="text-xs text-gray-400 mt-20">Stand: Januar 2026</p>
        </div>
      </div>
    </div>
  );
};

export default Datenschutz;